import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "2-state-02-triangle",
  "use": "2-state-02-triangle-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"2-state-02-triangle\">\n  <path d=\"M71.675 893.33l440.325-762.683 440.325 762.683z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol